const TRACKER_SOURCE = "TRACKER";

function normalizeSource(source) {
    return source || TRACKER_SOURCE;
}

function accountKey(account) {
    if (account && account.bindInfoId) {
        return `bind-${account.bindInfoId}`;
    }
    const source = normalizeSource(account && account.dataSource);
    const name = String((account && account.valorantUserName) || "").toLowerCase();
    return `${source}:${name}`;
}

function buildBindingSelection(gamerskyUserId, account) {
    if (account && account.bindInfoId) {
        return {
            gamerskyUserId,
            bindInfoId: account.bindInfoId,
        };
    }
    return {
        gamerskyUserId,
        valorantUserName: account && account.valorantUserName,
    };
}

function isAccountActive(account, activeBindInfoId, activeName, activeSource) {
    if (!account) {
        return false;
    }
    if (activeBindInfoId && account.bindInfoId) {
        return Number(account.bindInfoId) === Number(activeBindInfoId);
    }
    return normalizeSource(account.dataSource) === normalizeSource(activeSource)
        && String(account.valorantUserName || "").toLowerCase() === String(activeName || "").toLowerCase();
}

function isTrackerAccountBound(accounts, accountName) {
    const normalizedName = String(accountName || "").trim().toLowerCase();
    return (accounts || []).some((account) => account
        && normalizeSource(account.dataSource) === TRACKER_SOURCE
        && String(account.valorantUserName || "").trim().toLowerCase() === normalizedName);
}

function createLatestRequestGate() {
    let currentRequestId = 0;

    return {
        begin() {
            currentRequestId += 1;
            return currentRequestId;
        },
        invalidate() {
            currentRequestId += 1;
        },
        current() {
            return currentRequestId;
        },
        isCurrent(requestId) {
            return requestId === currentRequestId;
        },
    };
}

function shouldPreserveCurrentData(isFresh, preserveOnFailure, currentData) {
    return Boolean(currentData) && (Boolean(isFresh) || Boolean(preserveOnFailure));
}

function shouldReturnToBindingAfterRefresh(isFresh, error, source) {
    return isFresh === true
        && normalizeSource(source) === TRACKER_SOURCE
        && (error === "404" || error === 404);
}

function withTimeout(promise, timeoutMs) {
    const duration = Number(timeoutMs);
    if (!Number.isFinite(duration) || duration <= 0) {
        return Promise.resolve(promise);
    }

    return new Promise((resolve, reject) => {
        const timer = setTimeout(() => {
            const error = new Error("请求超时");
            error.code = "REQUEST_TIMEOUT";
            reject(error);
        }, duration);

        Promise.resolve(promise).then(
            (value) => {
                clearTimeout(timer);
                resolve(value);
            },
            (error) => {
                clearTimeout(timer);
                reject(error);
            }
        );
    });
}

module.exports = {
    TRACKER_SOURCE,
    accountKey,
    buildBindingSelection,
    createLatestRequestGate,
    isAccountActive,
    isTrackerAccountBound,
    normalizeSource,
    shouldPreserveCurrentData,
    shouldReturnToBindingAfterRefresh,
    withTimeout,
};
